import { useEffect, useRef, useState } from "react"
import Card from "../Card/Card"
import './Hand.scss'
import { SECTIONS } from "../PlayerSection/PlayerSection"
import MouseDropableSection from "../MouseDropableSection"
import { Dropdown, DropdownButton } from "react-bootstrap"
import { hideCard, shuffleArray, ungroupCard } from "../../Commons/Functions"

export default function Hand(props) {

    function setAllIsHiddenTo(val) {
        const sectionCards = props.sectionCards
        sectionCards.forEach((c, i) => {
            hideCard(c.card, val, props.playerId, props.opponentIds)
        })

        if (val == "opponent-only") {
            props.sendToHistory("hid his hand")
        } else if (val == "no") {
            props.sendToHistory("revealed his hand")
        }
        props.repositionCards()
    }

    function oneRandomlyToSection(val) {
        if (props.sectionCards.length === 0) { return }
        const c = props.sectionCards[Math.floor(Math.random() * props.sectionCards.length)];
        props.moveCard(c.card, val)
        props.repositionCards()
    }

    function allToSection(val) {
        props.sectionCards.forEach((c, i) => {
            props.moveCard(c.card, val)
        })
        props.repositionCards()
    }

    function allToDeckBottom() {
        let deck = [...props.deckRef.current]
        let hand = []

        props.visibleCardsRef.current = props.visibleCardsRef.current.filter(c => {
            if (c.position.section === SECTIONS.HAND) {
                ungroupCard(c, props.visibleCardsRef.current)
                c.counters = [{}, {}]
                hand.push(c)
                return false;
            }
            return true;
        });

        props.sendToHistory(`Put hand (${hand.length}) at the bottom of their deck`)

        shuffleArray(hand)
        deck = [...hand, ...deck]
        props.setDeck(deck)
        props.deckRef.current = deck
        props.repositionCards()
    }

    return (
        <div className="hand-board-section">
            <MouseDropableSection
                className="hand"
                sectionRef={props.handRef}
                section={SECTIONS.HAND}
                cardDraggedRef={props.cardDraggedRef}
                moveCard={props.moveCard}
                repositionCards={props.repositionCards}
            >
            </MouseDropableSection>
            <div className={"buttons d-flex flex-row position-absolute"}>
                <DropdownButton onClick={props.onClick} className="" title="">
                    <Dropdown.Item className="hide-all" onClick={() => allToDeckBottom()}>All to deck bottom</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item className="hide-all" onClick={() => oneRandomlyToSection(SECTIONS.DISCARD)}>Discard one randomly</Dropdown.Item>
                    <Dropdown.Item className="hide-all" onClick={() => allToSection(SECTIONS.DISCARD)}>Discard all</Dropdown.Item>
                    <Dropdown.Item className="hide-all" onClick={() => allToSection(SECTIONS.EXILE)}>Remove all</Dropdown.Item>
                    <Dropdown.Item className="hide-all" onClick={() => allToSection(SECTIONS.EXILE_HIDDEN)}>Remove all hidden</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item className="reveal-all" onClick={() => setAllIsHiddenTo("no")}>Reveal all</Dropdown.Item>
                    <Dropdown.Item className="hide-all" onClick={() => setAllIsHiddenTo("opponent-only")}>Hide all</Dropdown.Item>
                </DropdownButton>
            </div>
        </div>
    )
}